import React from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link, NavLink } from 'react-router-dom';

function NavBar() {
  return (
    <Navbar collapseOnSelect expand="lg" variant="dark" className="site-nav">
      <Container className="nav-inner">
        <Navbar.Brand as={Link} to="/">
          <span className="brand-mark">CG</span>
          <span className="brand-name">Car Gallery</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-navigation" />
        <Navbar.Collapse id="main-navigation">
          <Nav className="ms-auto">
            <Nav.Link as={NavLink} to="/" end>Ana Sayfa</Nav.Link>
            <Nav.Link as={NavLink} to="/carshow">Koleksiyon</Nav.Link>
            <Nav.Link as={NavLink} to="/cartable">Araç Listesi</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
